/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import LinkIcon from '@mui/icons-material/Link';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import TitleIcon from '@mui/icons-material/Title';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import RedoIcon from '@mui/icons-material/Redo';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import UndoIcon from '@mui/icons-material/Undo';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import NoteIcon from '@mui/icons-material/Note';
import SaveIcon from '@mui/icons-material/Save';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  Divider,
  Grid,
  IconButton,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import {
  convertTextToHtml,
  findCloud,
  GetDarkVideoName,
  getDefaultAlertProps,
  getImageVideoSize,
  getPageNumId,
  getShortText,
  secureContent,
  selectTheme,
} from '../../utils/utils';
import { MyAlert } from '../UI/MyAlert';
import { IAlertProps } from '../../interface/IAlertProps';
import { BackDropDiv } from '../backdrop/BackDropDiv';
import { IApiResult } from '../../interface/IApiResult';
import {
  ACCEPTED_INPUT_FORM_FILE_TYPES,
  ACCEPTED_INPUT_FORM_FILE_TYPES_MP3,
  API_STATUS_PROBLEM,
  AUDIO_TYPE,
  DARK_THEME,
  IMAGE_TYPE,
  LIGHT_THEME,
  SPACE_AUDIO,
  SPACE_CLOUD,
  SPACE_CONSPECT,
  SPACE_DESIGN,
  SPACE_IMAGE,
  SPACE_IMAGE_LINK,
  SPACE_TABLE,
  SPACE_TERMIN,
} from '../../constant/constants';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { AddFile } from '../add-file/AddFile';
import { RESOURCE_URL } from '../../setting/AppSettings';
import { WorkspaceDto } from '../../dto/WorkspaceDto';
import { apiDeleteFile } from '../../service/apiDeleteFile';
import { DialogConfirmation } from '../confirmation/DialogConfirmation';
import { MyTextFiledLection } from '../UI/MyTextFieldLection';
import { apiSaveLection } from '../../service/apiSaveLection';
import { MyTextFiled } from '../UI/MyTextField';
import { apiUpdateDesign } from '../../service/apiUpdateDesign';
import { DialogAddAnnotation } from '../dialog/DialogAddAnnatation';
import { AnnotaionDto, LectionImageDto } from '../../dto/LectionImageDto';
import { WorksapceAnnotationItemDiv } from './WorksapceAnnotationItemDiv';
import { CopyArrDto } from '../../dto/CopyArrDto';
import { DialogAddImage } from '../dialog/DialogAddImage';
import { WorksapceSlideImageItemDiv } from './WorksapceSlideImageItemDiv';
import { apiDeleteImage } from '../../service/apiDeleteImage';
import { apiDeletePage } from '../../service/apiDeletePage';
import { apiUpdateTable } from '../../service/apiUpdateTable';
import { DialogAddToCloud } from '../dialog/DialogAddToCloud';
import { DialogGetFromCloud } from '../dialog/DialogGetFromCloud';
import { CloudDto } from '../../dto/CloudDto';
import { apiDeleteCloudLink } from '../../service/apiDeleteCloudLink';
import { MyButton } from '../UI/MyButton';
import { apiDeleteAllImageLink } from '../../service/apiDeleteAllImageLink';
import { apiDeleteAllImage } from '../../service/apiDeleteAllImage';

interface Props {
  workspaceDto: WorkspaceDto;
  cloudDto: CloudDto[];
  onUpdate: (e?: any) => void;
}

export const WorkspaceDivItem: FunctionComponent<Props> = ({
  workspaceDto,
  cloudDto,
  onUpdate,
}) => {
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const [copyAddDto, setCopyAddDto] = useState<CopyArrDto>({
    start: -1,
    finish: -1,
    text: '',
    textMore: '',
  });
  const [openDialogConfirmation, setOpenDialogConfirmation] = useState(false);
  const [openDialogConfirmationCloudLink, setOpenDialogConfirmationCloudLink] =
    useState(false);
  const [
    openDialogDeletePageConfirmation,
    setOpenDialogDeletePageConfirmation,
  ] = useState(false);
  const [openDialogCloud, setOpenDialogCloud] = useState(false);
  const [openDialogImageConfirmation, setOpenDialogImageConfirmation] =
    useState(false);
  const [
    openDialogAllImageLinkConfirmation,
    setOpenDialogAllImageLinkConfirmation,
  ] = useState(false);
  const [openDialogAllImageConfirmation, setOpenDialogAllImageConfirmation] =
    useState(false);
  const [openDialogCloudAdd, setOpneDialogCloudAdd] = useState(false);
  const [openDialogTerminAdd, setOpneDialogTerminAdd] = useState(false);
  const [openDialogImageAdd, setOpneDialogImageAdd] = useState(false);
  const [nameFile, setNameFile] = useState('');
  const [typeFile, setTypeFile] = useState(0);
  const [pageDto, setPageDto] = useState<WorkspaceDto>(workspaceDto);
  const [pageNum, setPageNum] = useState(1);
  const [arrBack, setArrBack] = useState<WorkspaceDto[]>([]);
  const [arrNext, setArrNext] = useState<WorkspaceDto[]>([]);
  const [backDrop, setBackDrop] = useState(false);
  const { section, route } = useParams();
  const [page, setPage] = useState(getPageNumId(pageDto.id));
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [annatationDto, setAnnatationDto] = useState<AnnotaionDto>({
    id: '',
    title: '',
    text: '',
  });

  const [deleteImageDto, setDeleteImageDto] = useState<LectionImageDto>({
    id: '',
    type: -1,
    position: -1,
    descr: '',
    timeBegin: -1,
    zoomImage: {
      name: '',
      base64Image: '',
      zoom: 1,
      coordinate: '',
      height: -1,
      width: -1,
    },
    images: [],
  });

  const saveLection = async () => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiSaveLection(
      section ?? '',
      route ?? '',
      page ?? '',
      pageDto
    );
    if (apiResult.isSuccess) {
      setArrBack([]);
      setArrNext([]);
      onUpdate();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const updateDesgin = async () => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiUpdateDesign(
      section ?? '',
      route ?? '',
      page ?? '',
      pageDto
    );
    if (apiResult.isSuccess) {
      onUpdate();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const updateTable = async () => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiUpdateTable(
      section ?? '',
      route ?? '',
      page ?? '',
      pageDto
    );
    if (apiResult.isSuccess) {
      onUpdate();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const handleDeletePage = async (num: string) => {
    setPageNum(parseInt(getPageNumId(num), 10));
    setOpenDialogDeletePageConfirmation(true);
  };

  const handleSendToCloud = async (num: string) => {
    setPageNum(parseInt(getPageNumId(num), 10));
    setOpenDialogCloud(true);
  };

  const deletePage = async (confirm: boolean) => {
    if (!confirm) {
      setOpenDialogDeletePageConfirmation(false);
      return;
    }
    setBackDrop(true);
    const apiResult: IApiResult = await apiDeletePage(
      section ?? '',
      route ?? '',
      `${pageNum}`
    );
    if (apiResult.isSuccess) {
      onUpdate(true);
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
    setOpenDialogDeletePageConfirmation(false);
  };

  const deleteFile = async (confirm: boolean) => {
    if (!confirm) {
      setOpenDialogConfirmation(false);
      return;
    }
    setBackDrop(true);
    const apiResult: IApiResult = await apiDeleteFile(
      typeFile,
      section ?? '',
      route ?? '',
      page ?? '',
      nameFile
    );
    if (apiResult.isSuccess) {
      onUpdate();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
    setOpenDialogConfirmation(false);
  };

  const deleteFileImage = async (confirm: boolean) => {
    if (!confirm) {
      setOpenDialogImageConfirmation(false);
      return;
    }
    setBackDrop(true);
    const apiResult: IApiResult = await apiDeleteImage(
      section ?? '',
      route ?? '',
      page ?? '',
      deleteImageDto
    );
    if (apiResult.isSuccess) {
      onUpdate();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
    setOpenDialogImageConfirmation(false);
  };

  const deleteFileAllImageLink = async (confirm: boolean) => {
    if (!confirm) {
      setOpenDialogAllImageLinkConfirmation(false);
      return;
    }
    setBackDrop(true);
    const apiResult: IApiResult = await apiDeleteAllImageLink(
      section ?? '',
      route ?? '',
      page ?? ''
    );
    if (apiResult.isSuccess) {
      onUpdate();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
    setOpenDialogAllImageLinkConfirmation(false);
  };

  const deleteFileAllImage = async (confirm: boolean) => {
    if (!confirm) {
      setOpenDialogAllImageConfirmation(false);
      return;
    }
    setBackDrop(true);
    const apiResult: IApiResult = await apiDeleteAllImage(
      section ?? '',
      route ?? '',
      page ?? ''
    );
    if (apiResult.isSuccess) {
      onUpdate();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
    setOpenDialogAllImageConfirmation(false);
  };

  const consoleAddAfterRedo = (text: string) => {
    setPageDto({
      ...pageDto,
      text: convertTextToHtml(text),
    });
  };

  const addToRedo = (text: string) => {
    // const dto = pageDto;
    // dto.text = text;
    setArrBack([...arrBack, pageDto]);
    consoleAddAfterRedo(text);
  };

  const getRedo = () => {
    if (arrNext.length > 0) {
      setPageDto(arrNext[arrNext.length - 1]);
      setArrBack([...arrBack, pageDto]);
      setArrNext(arrNext.slice(0, arrNext.length - 1));
    }
  };

  const getUndo = () => {
    if (arrBack.length > 0) {
      setPageDto(arrBack[arrBack.length - 1]);
      setArrNext([...arrNext, pageDto]);
      setArrBack(arrBack.slice(0, arrBack.length - 1));
    }
  };

  const getSelection = () => {
    let arr: CopyArrDto = {
      start: -1,
      finish: -1,
      text: '',
      textMore: '',
    };

    const textarea = document.getElementById(
      `textarea${pageDto.id}`
    ) as HTMLInputElement;
    let start = textarea.selectionStart;
    let finish = textarea.selectionEnd;
    if (start === finish) {
      // all browsers, except IE before version 9
      const text = document.getSelection();
      const content = textarea.value;
      if (text !== null) {
        start = content.indexOf(text.toString());
        finish = content.indexOf(text.toString()) + text.toString().length;
      }
    }

    if (start !== null && finish !== null) {
      const sel = textarea.value.substring(start, finish);
      let starMore = start - 15;
      if (starMore < 0) {
        starMore = 0;
      }
      const finishMore = finish + 15;
      const selMore = textarea.value.substring(starMore, finishMore);
      arr = {
        start,
        finish,
        text: sel,
        textMore: selMore,
      };
    }
    return arr;
  };

  const openAddDialog = () => {
    const arr: CopyArrDto = getSelection();
    if (arr.text !== '') {
      setCopyAddDto(arr);
      setOpneDialogTerminAdd(true);
    }
  };

  const openAddCloudDialog = () => {
    const arr: CopyArrDto = getSelection();
    if (arr.text !== '') {
      setCopyAddDto(arr);
      setOpneDialogCloudAdd(true);
    }
  };

  const openAddImageDialog = () => {
    const arr: CopyArrDto = getSelection();
    if (arr.text !== '') {
      setCopyAddDto(arr);
      setOpneDialogImageAdd(true);
    }
  };

  const addTerminToText = (id: string) => {
    if (copyAddDto.text !== '' && id !== '') {
      let lection = pageDto.text.replaceAll('#**#', '"');
      const one = copyAddDto.text.replaceAll('\n', '</br>');
      const two = copyAddDto.textMore.replaceAll('\n', '</br>');
      const replacTextMore = two.replace(
        one,
        `${one}<a href="#question_${id}" style="color:linkColor; font-weight: 600; text-decoration: none"><sup>@</sup> </a>`
      );
      lection = lection.replace(two, replacTextMore);
      setPageDto({
        ...pageDto,
        text: convertTextToHtml(lection),
      });
      setArrBack([...arrBack, pageDto]);
    }
    setCopyAddDto({
      start: -1,
      finish: -1,
      text: '',
      textMore: '',
    });
  };

  const addCloudToText = (id: string) => {
    if (copyAddDto.text !== '' && id !== '') {
      let lection = pageDto.text.replaceAll('#**#', '"');
      const one = copyAddDto.text.replaceAll('\n', '</br>');
      const two = copyAddDto.textMore.replaceAll('\n', '</br>');
      const replacTextMore = two.replace(
        one,
        `${one}<a href="#more_${id}" style="color:linkColor; font-weight: 600; text-decoration: none"><sup>Info</sup> </a>`
      );
      lection = lection.replace(two, replacTextMore);
      setPageDto({
        ...pageDto,
        text: convertTextToHtml(lection),
      });
      setArrBack([...arrBack, pageDto]);
    }
    setCopyAddDto({
      start: -1,
      finish: -1,
      text: '',
      textMore: '',
    });
  };

  const addImageToText = (id: string) => {
    if (copyAddDto.text !== '' && id !== '') {
      let lection = pageDto.text.replaceAll('#**#', '"');
      const one = copyAddDto.text.replaceAll('\n', '</br>');
      const two = copyAddDto.textMore.replaceAll('\n', '</br>');
      const replacTextMore = two.replace(
        one,
        `<a href="#update_${id}" id="${id}" style="background-color: undefined; color:linkColor; font-weight: 600">${one}</a>`
      );
      lection = lection.replace(two, replacTextMore);
      setPageDto({
        ...pageDto,
        text: convertTextToHtml(lection),
      });
      setArrBack([...arrBack, pageDto]);
    }
    setCopyAddDto({
      start: -1,
      finish: -1,
      text: '',
      textMore: '',
    });
  };

  const boldText = () => {
    const arr: CopyArrDto = getSelection();
    if (arr.text !== '') {
      let lection = pageDto.text;
      const one = arr.text.replaceAll('\n', '</br>');
      const two = arr.textMore.replaceAll('\n', '</br>');
      let replacTextMore = two.replace(one, `<b>${one}</b>`);
      if (two.includes('<b>') && two.includes('</b>')) {
        replacTextMore = replacTextMore.replaceAll('<b>', '');
        replacTextMore = replacTextMore.replaceAll('</b>', '');
      }
      lection = lection.replace(two, replacTextMore);
      setPageDto({
        ...pageDto,
        text: convertTextToHtml(lection),
      });
      setArrBack([...arrBack, pageDto]);
    }
  };

  const zagolovok = () => {
    const arr: CopyArrDto = getSelection();
    if (arr.text !== '') {
      let lection = pageDto.text.replaceAll('#**#', '"');
      const one = arr.text.replaceAll('\n', '</br>');
      const two = arr.textMore.replaceAll('\n', '</br>');
      let replacTextMore = two.replace(
        one,
        `<center><font style="font-weight: 600; font-size: 20px">${one}</font></center>`
      );
      if (
        two.includes(
          '<center><font style="font-weight: 600; font-size: 20px">'
        ) &&
        two.includes('</font></center>')
      ) {
        replacTextMore = replacTextMore.replaceAll(
          '<center><font style="font-weight: 600; font-size: 20px">',
          ''
        );
        replacTextMore = replacTextMore.replaceAll('</font></center>', '');
      }

      lection = lection.replace(two, replacTextMore);
      setPageDto({
        ...pageDto,
        text: convertTextToHtml(lection),
      });
      setArrBack([...arrBack, pageDto]);
    }
  };

  const podzagolovok = () => {
    const arr: CopyArrDto = getSelection();
    if (arr.text !== '') {
      let lection = pageDto.text.replaceAll('#**#', '"');
      const one = arr.text.replaceAll('\n', '</br>');
      const two = arr.textMore.replaceAll('\n', '</br>');
      let replacTextMore = two.replace(one, `<center><b>${one}</b></center>`);
      if (two.includes('<b>') && two.includes('</b>')) {
        replacTextMore = replacTextMore.replaceAll('<center><b>', '');
        replacTextMore = replacTextMore.replaceAll('</b></center>', '');
      }

      lection = lection.replace(two, replacTextMore);
      setPageDto({
        ...pageDto,
        text: convertTextToHtml(lection),
      });
      setArrBack([...arrBack, pageDto]);
    }
  };

  const addEnter = () => {
    const arr: CopyArrDto = getSelection();
    if (arr.text !== '') {
      let lection = pageDto.text.replaceAll('#**#', '"');
      const one = arr.text.replaceAll('\n', '</br>');
      const two = arr.textMore.replaceAll('\n', '</br>');
      let replacTextMore = two.replace(
        one,
        `<div style="margin-top: 10px;"> </div>${one}`
      );
      if (two.includes('<div style="margin-top: 10px;"> </div>')) {
        replacTextMore = replacTextMore.replaceAll(
          '<div style="margin-top: 10px;"> </div>',
          ''
        );
      }

      lection = lection.replace(two, replacTextMore);
      setPageDto({
        ...pageDto,
        text: convertTextToHtml(lection),
      });
      setArrBack([...arrBack, pageDto]);
    }
  };

  const italicText = () => {
    const arr: CopyArrDto = getSelection();
    if (arr.text !== '') {
      let lection = pageDto.text;
      const one = arr.text.replaceAll('\n', '</br>');
      const two = arr.textMore.replaceAll('\n', '</br>');
      let replacTextMore = two.replace(one, `<i>${one}</i>`);
      if (two.includes('<i>') && two.includes('</i>')) {
        replacTextMore = replacTextMore.replaceAll('<i>', '');
        replacTextMore = replacTextMore.replaceAll('</i>', '');
      }

      lection = lection.replace(two, replacTextMore);

      setPageDto({
        ...pageDto,
        text: convertTextToHtml(lection),
      });
      setArrBack([...arrBack, pageDto]);
    }
  };

  const noteBane = () => {
    const arr: CopyArrDto = getSelection();
    if (arr.text !== '') {
      let lection = pageDto.text.replaceAll('#**#', '"');
      const one = arr.text.replaceAll('\n', '</br>');
      const two = arr.textMore.replaceAll('\n', '</br>');
      let replacTextMore = two.replace(
        one,
        `<div style="background-color:#e0e0e0; border: 1px solid #e0e0e0; border-radius: 5px; padding: 5px; margin-top: 10px; margin-bottom: 10px "><font style="font-weight: 600">N/B:</font>${one}</div>`
      );
      if (
        two.includes(
          '<div style="background-color:#e0e0e0; border: 1px solid #e0e0e0; border-radius: 5px; padding: 5px; margin-top: 10px; margin-bottom: 10px "><font style="font-weight: 600">N/B:</font>'
        ) &&
        two.includes('</div>')
      ) {
        replacTextMore = replacTextMore.replaceAll(
          '<div style="background-color:#e0e0e0; border: 1px solid #e0e0e0; border-radius: 5px; padding: 5px; margin-top: 10px; margin-bottom: 10px "><font style="font-weight: 600">N/B:</font>',
          ''
        );
        replacTextMore = replacTextMore.replaceAll('</div>', '');
      }

      lection = lection.replace(two, replacTextMore);

      setPageDto({
        ...pageDto,
        text: convertTextToHtml(lection),
      });
      setArrBack([...arrBack, pageDto]);
    }
  };

  const listPointText = () => {
    const arr: CopyArrDto = getSelection();
    if (arr.text !== '') {
      let lection = pageDto.text.replaceAll('#**#', '"');
      const one = arr.text.replaceAll('\n', '</br>');
      const two = arr.textMore.replaceAll('\n', '</br>');
      let replacTextMore = two.replace(
        one,
        `<ul style="margin-top: 0px; margin-bottom: 0px"><li>${one.replaceAll(
          '</br>',
          `</li><li>`
        )}</li></ul>`
      );
      replacTextMore = replacTextMore.replace('</ul></br>', `</ul>`);
      if (
        two.includes('<ul style="margin-top: 0px; margin-bottom: 0px">') &&
        two.includes('</ul>')
      ) {
        replacTextMore = replacTextMore.replaceAll('</li><li>', '</br>');
        replacTextMore = replacTextMore.replaceAll(
          '<ul style="margin-top: 0px; margin-bottom: 0px">',
          ''
        );
        replacTextMore = replacTextMore.replaceAll('</ul>', '');
        replacTextMore = replacTextMore.replaceAll('<li>', '');
        replacTextMore = replacTextMore.replaceAll('</li>', '');
      }

      lection = lection.replace(two, replacTextMore);

      setPageDto({
        ...pageDto,
        text: convertTextToHtml(lection),
      });
      setArrBack([...arrBack, pageDto]);
    }
  };

  const listPointText2 = () => {
    const arr: CopyArrDto = getSelection();
    if (arr.text !== '') {
      let lection = pageDto.text.replaceAll('#**#', '"');
      const one = arr.text.replaceAll('\n', '</br>');
      const two = arr.textMore.replaceAll('\n', '</br>');
      let replacTextMore = two.replace(
        one,
        `<ul type="circle" style="margin-top: 0px; margin-left: 20px; margin-bottom: 0px"><li>${one.replaceAll(
          '</br>',
          `</li><li>`
        )}</li></ul>`
      );
      replacTextMore = replacTextMore.replace('</ul></br>', `</ul>`);
      if (
        two.includes(
          '<ul type="circle" style="margin-top: 0px; margin-left: 20px; margin-bottom: 0px">'
        ) &&
        two.includes('</ul>')
      ) {
        replacTextMore = replacTextMore.replaceAll('</li><li>', '</br>');
        replacTextMore = replacTextMore.replaceAll(
          '<ul type="circle" style="margin-top: 0px; margin-left: 20px; margin-bottom: 0px">',
          ''
        );
        replacTextMore = replacTextMore.replaceAll('</ul>', '');
        replacTextMore = replacTextMore.replaceAll('<li>', '');
        replacTextMore = replacTextMore.replaceAll('</li>', '');
      }

      lection = lection.replace(two, replacTextMore);

      setPageDto({
        ...pageDto,
        text: convertTextToHtml(lection),
      });
      setArrBack([...arrBack, pageDto]);
    }
  };

  const listPointText3 = () => {
    const arr: CopyArrDto = getSelection();
    if (arr.text !== '') {
      let lection = pageDto.text.replaceAll('#**#', '"');
      const one = arr.text.replaceAll('\n', '</br>');
      const two = arr.textMore.replaceAll('\n', '</br>');
      let replacTextMore = two.replace(
        one,
        `<ul type="square" style="margin-top: 0px; margin-left: 40px; margin-bottom: 0px"><li>${one.replaceAll(
          '</br>',
          `</li><li>`
        )}</li></ul>`
      );
      replacTextMore = replacTextMore.replace('</ul></br>', `</ul>`);
      if (
        two.includes(
          '<ul type="square" style="margin-top: 0px; margin-left: 40px; margin-bottom: 0px">'
        ) &&
        two.includes('</ul>')
      ) {
        replacTextMore = replacTextMore.replaceAll('</li><li>', '</br>');
        replacTextMore = replacTextMore.replaceAll(
          '<ul type="square" style="margin-top: 0px; margin-left: 40px; margin-bottom: 0px">',
          ''
        );
        replacTextMore = replacTextMore.replaceAll('</ul>', '');
        replacTextMore = replacTextMore.replaceAll('<li>', '');
        replacTextMore = replacTextMore.replaceAll('</li>', '');
      }

      lection = lection.replace(two, replacTextMore);

      setPageDto({
        ...pageDto,
        text: convertTextToHtml(lection),
      });
      setArrBack([...arrBack, pageDto]);
    }
  };

  const listNumberText = () => {
    const arr: CopyArrDto = getSelection();
    if (arr.text !== '') {
      let lection = pageDto.text.replaceAll('#**#', '"');
      const one = arr.text.replaceAll('\n', '</br>');
      const two = arr.textMore.replaceAll('\n', '</br>');
      let replacTextMore = two.replace(
        one,
        `<ol style="margin-top: 0px; margin-bottom: 0px"><li>${one.replaceAll(
          '</br>',
          `</li><li>`
        )}</li></ol>`
      );
      replacTextMore = replacTextMore.replace('</ol></br>', `</ol>`);
      if (
        two.includes('<ol style="margin-top: 0px; margin-bottom: 0px">') &&
        two.includes('</ol>')
      ) {
        replacTextMore = replacTextMore.replaceAll('</li><li>', '</br>');
        replacTextMore = replacTextMore.replaceAll(
          '<ol style="margin-top: 0px; margin-bottom: 0px">',
          ''
        );
        replacTextMore = replacTextMore.replaceAll('</ol>', '</br>');
        replacTextMore = replacTextMore.replaceAll('<li>', '');
        replacTextMore = replacTextMore.replaceAll('</li>', '');
      }

      lection = lection.replace(two, replacTextMore);

      setPageDto({
        ...pageDto,
        text: convertTextToHtml(lection),
      });
      setArrBack([...arrBack, pageDto]);
    }
  };

  const listLetterText = () => {
    const arr: CopyArrDto = getSelection();
    if (arr.text !== '') {
      let lection = pageDto.text.replaceAll('#**#', '"');
      const one = arr.text.replaceAll('\n', '</br>');
      const two = arr.textMore.replaceAll('\n', '</br>');
      let replacTextMore = two.replace(
        one,
        `<ol type="a" style="margin-top: 0px; margin-bottom: 0px"><li>${one.replaceAll(
          '</br>',
          `</li><li>`
        )}</li></ol>`
      );
      replacTextMore = replacTextMore.replace('</ol></br>', `</ol>`);
      if (
        two.includes(
          '<ol type="a" style="margin-top: 0px; margin-bottom: 0px">'
        ) &&
        two.includes('</ol>')
      ) {
        replacTextMore = replacTextMore.replaceAll('</li><li>', '</br>');
        replacTextMore = replacTextMore.replaceAll(
          '<ol type="a" style="margin-top: 0px; margin-bottom: 0px">',
          ''
        );
        replacTextMore = replacTextMore.replaceAll('</ol>', '</br>');
        replacTextMore = replacTextMore.replaceAll('<li>', '');
        replacTextMore = replacTextMore.replaceAll('</li>', '');
      }

      lection = lection.replace(two, replacTextMore);

      setPageDto({
        ...pageDto,
        text: convertTextToHtml(lection),
      });
      setArrBack([...arrBack, pageDto]);
    }
  };

  const cleanText = () => {
    const arr: CopyArrDto = getSelection();
    if (arr.text !== '') {
      let lection = pageDto.text.replaceAll('#**#', '"');
      const one = arr.text.replaceAll('\n', '</br>');
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const two = arr.textMore.replaceAll('\n', '</br>');
      let replacTextMore = one.replaceAll('</li><li>', '</br>');
      replacTextMore = replacTextMore.replaceAll(
        '<ul style="margin-top: 0px; margin-bottom: 0px">',
        ''
      );
      replacTextMore = replacTextMore.replaceAll(
        '<ul type="square" style="margin-top: 0px; margin-left: 40px; margin-bottom: 0px">',
        ''
      );
      replacTextMore = replacTextMore.replaceAll(
        '<ul type="circle" style="margin-top: 0px; margin-left: 20px; margin-bottom: 0px">',
        ''
      );
      replacTextMore = replacTextMore.replaceAll(
        '<ol style="margin-top: 0px; margin-bottom: 0px">',
        ''
      );
      replacTextMore = replacTextMore.replaceAll(
        '<ol type="a" style="margin-top: 0px; margin-bottom: 0px">',
        ''
      );
      replacTextMore = replacTextMore.replaceAll(
        '<center><font style="font-weight: 600; font-size: 20px">',
        ''
      );
      replacTextMore = replacTextMore.replaceAll(
        '<div style="margin-top: 10px;"> </div>',
        ''
      );
      replacTextMore = replacTextMore.replaceAll('</font></center>', '');
      replacTextMore = replacTextMore.replaceAll('<center><b>', '');
      replacTextMore = replacTextMore.replaceAll('</b></center>', '');
      replacTextMore = replacTextMore.replaceAll('</ol>', '</br>');
      replacTextMore = replacTextMore.replaceAll('<li>', '');
      replacTextMore = replacTextMore.replaceAll('</li>', '');
      replacTextMore = replacTextMore.replaceAll('<b>', '');
      replacTextMore = replacTextMore.replaceAll('</b>', '');
      replacTextMore = replacTextMore.replaceAll('<i>', '');
      replacTextMore = replacTextMore.replaceAll('</i>', '');
      replacTextMore = replacTextMore.replaceAll(
        '<div style="background-color:#e0e0e0; border: 1px solid #e0e0e0; border-radius: 5px; padding: 5px; margin-top: 10px; margin-bottom: 10px "><font style="font-weight: 600">N/B:</font>',
        ''
      );
      replacTextMore = replacTextMore.replaceAll('</div>', '');
      replacTextMore = replacTextMore.replaceAll(
        '<ul style="margin-top: 0px; margin-bottom: 0px">',
        ''
      );
      replacTextMore = replacTextMore.replaceAll('</ul>', '');

      lection = lection.replace(one, replacTextMore);

      setPageDto({
        ...pageDto,
        text: convertTextToHtml(lection),
      });
      setArrBack([...arrBack, pageDto]);
    }
  };

  const [valueTabNew, setValueTabNew] = React.useState(SPACE_CONSPECT);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabNew(newValue);
  };

  const handleDelete = async (
    name: string,
    type: number,
    dto?: AnnotaionDto
  ) => {
    setNameFile(name);
    setTypeFile(type);
    if (dto !== undefined) {
      setAnnatationDto(dto);
    }
    setOpenDialogConfirmation(true);
  };

  const handleDeleteAllImageLink = async () => {
    setOpenDialogAllImageLinkConfirmation(true);
  };

  const handleDeleteAllImage = async () => {
    setOpenDialogAllImageConfirmation(true);
  };

  const handleDeleteImage = async (
    name: string,
    type: number,
    dto?: LectionImageDto
  ) => {
    setNameFile(name);
    setTypeFile(type);
    if (dto !== undefined) {
      setDeleteImageDto(dto);
    }
    setOpenDialogImageConfirmation(true);
  };

  const onUpdateFileUpload = () => {
    setValueTabNew(SPACE_CONSPECT);
    onUpdate();
  };

  useEffect(() => {
    setPage(getPageNumId(pageDto.id));
    setPageDto(workspaceDto);
    setAnnatationDto({
      id: '',
      title: '',
      text: '',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaceDto]);

  const [cloudLinkDto, setCloudLinkDto] = useState<CloudDto>({
    id: '',
    name: '',
  });

  const handleDeleteCloudLink = async (dto: CloudDto) => {
    setCloudLinkDto(dto);
    setOpenDialogConfirmationCloudLink(true);
  };

  const deleteCloudLink = async (confirm: boolean) => {
    if (!confirm) {
      setOpenDialogConfirmationCloudLink(false);
      return;
    }
    const apiResult: IApiResult = await apiDeleteCloudLink(
      section ?? '',
      route ?? '',
      page ?? '',
      cloudLinkDto.id
    );
    if (apiResult.isSuccess) {
      onUpdate();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setOpenDialogConfirmationCloudLink(false);
  };

  return (
    <Stack width="100%" alignItems="center">
      <BackDropDiv open={backDrop} />
      <MyAlert
        message={alertProps.message}
        severity={alertProps.severity}
        onClose={() => setAlertProps({ ...alertProps, message: '' })}
      />
      <Stack width="100%" spacing={0}>
        <div>
          <Accordion>
            <Stack direction="row" justifyContent="space-between">
              <Stack
                width="200px"
                direction="row"
                padding="10px"
                alignItems="center"
                spacing={1}
              >
                <IconButton
                  size="small"
                  onClick={() => handleDeletePage(pageDto.id)}
                >
                  <DeleteIcon
                    fontSize="small"
                    sx={{
                      color: '#f44336',
                    }}
                  />
                </IconButton>
                <IconButton
                  disabled={findCloud(cloudDto, pageDto.id)}
                  size="small"
                  style={{
                    marginRight: '20px',
                  }}
                  onClick={() => handleSendToCloud(pageDto.id)}
                >
                  <CloudUploadIcon
                    fontSize="small"
                    sx={{
                      color: !findCloud(cloudDto, pageDto.id)
                        ? '#00bcd4'
                        : '#e0e0e0',
                    }}
                  />
                </IconButton>
                <Typography
                  component="span"
                  style={{
                    fontFamily: 'sans-serif',
                    fontSize: '16px',
                    overflow: 'auto',
                    fontWeight: '700',
                    textAlign: 'left',
                    lineHeight: '22px',
                  }}
                >
                  Слайд {pageDto.pageNum}
                </Typography>
              </Stack>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Stack width="100%" direction="row" spacing={2}>
                  <Typography
                    style={{
                      fontFamily: 'sans-serif',
                      fontSize: '14px',
                      overflow: 'auto',
                      fontWeight: '400',
                      textAlign: 'left',
                      lineHeight: '22px',
                    }}
                    component="html"
                  >
                    <div
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        __html: getShortText(
                          pageDto.text.replaceAll('#**#', '"')
                        ),
                      }}
                    />
                  </Typography>
                </Stack>
              </AccordionSummary>
            </Stack>

            <AccordionDetails>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                  value={valueTabNew}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab label="Конспект" value={SPACE_CONSPECT} />
                  <Tab label="Ссылки на изображения" value={SPACE_IMAGE_LINK} />
                  <Tab label="Термины" value={SPACE_TERMIN} />
                  <Tab label="Ссылки в облако" value={SPACE_CLOUD} />
                  <Tab label="Дизайн" value={SPACE_DESIGN} />
                  <Tab label="Изображения" value={SPACE_IMAGE} />
                  <Tab label="Таблицы" value={SPACE_TABLE} />
                  <Tab label="Аудиозапись" value={SPACE_AUDIO} />
                </Tabs>
              </Box>
              <Stack marginBottom="20px">
                <div> </div>
              </Stack>
              {valueTabNew === SPACE_IMAGE && (
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                        width="100%"
                      >
                        {pageDto.images.length === 0 && (
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontWeight: 400,
                              fontSize: '18px',
                              color: '#000000',
                            }}
                            component="text"
                          >
                            Нет изображений
                          </Typography>
                        )}
                      </Stack>
                      <Stack direction="row" spacing={2}>
                        <MyButton
                          text="Удалить все изображения"
                          background="#9c27b0"
                          width="250px"
                          height="50px"
                          onClick={() => handleDeleteAllImage()}
                        />
                        <AddFile
                          key={pageDto.id}
                          workspaceDto={pageDto}
                          idPage={page}
                          name="File"
                          type={IMAGE_TYPE}
                          singleFileOnly={false}
                          icon={
                            <FileUploadIcon
                              sx={{ color: '#9c27b0' }}
                              fontSize="large"
                            />
                          }
                          accept={ACCEPTED_INPUT_FORM_FILE_TYPES}
                          onUpdate={onUpdateFileUpload}
                        />{' '}
                      </Stack>
                    </Stack>
                  </Grid>
                  {pageDto.images.map((item) => (
                    <Grid item xs={2}>
                      <Card style={{ width: '100%' }}>
                        <Stack direction="row" spacing={1}>
                          <Stack
                            style={{
                              position: 'absolute',
                            }}
                          >
                            <IconButton
                              size="medium"
                              onClick={() =>
                                handleDelete(item.name, IMAGE_TYPE)
                              }
                            >
                              <DeleteIcon
                                fontSize="medium"
                                sx={{
                                  color: '#f44336',
                                }}
                              />
                            </IconButton>
                          </Stack>
                          <Stack
                            width="100%"
                            alignItems="center"
                            justifyContent="center"
                          >
                            {item.name.includes('.png') && (
                              <img
                                width={getImageVideoSize(item, 200, 200)[0]}
                                height={getImageVideoSize(item, 200, 200)[1]}
                                alt="not found"
                                src={`https://uchianat.ru/api/contentUrl.php?section=${section}&lectionId=${route}&page=page_${page}&name=${
                                  item.name
                                }&${secureContent()}`}
                              />
                            )}
                            {item.name.includes('.mp4') && (
                              <video
                                width="90%"
                                playsInline
                                autoPlay
                                muted
                                loop
                              >
                                <source
                                  src={`https://uchianat.ru/api/contentUrl.php?section=${section}&lectionId=${route}&page=page_${page}&name=${
                                    item.name
                                  }&${secureContent()}`}
                                  type="video/mp4"
                                />
                              </video>
                            )}
                          </Stack>
                        </Stack>

                        <div
                          onClick={() =>
                            navigator.clipboard.writeText(item.name)
                          }
                          style={{
                            padding: '10px',
                            fontSize: '12px',
                          }}
                        >
                          {GetDarkVideoName(
                            item.name,
                            workspaceDto.videoMetadata
                          )}
                        </div>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              )}
              {valueTabNew === SPACE_CONSPECT && (
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Stack
                      direction="row"
                      style={{
                        background: '#FFFFFF',
                      }}
                      spacing={1}
                    >
                      <IconButton
                        size="medium"
                        disabled={arrBack.length === 0}
                        onClick={() => saveLection()}
                      >
                        <SaveIcon
                          fontSize="medium"
                          sx={{
                            color: arrBack.length === 0 ? '#eeeeee' : '#9c27b0',
                          }}
                        />
                      </IconButton>
                      <Divider orientation="vertical" flexItem />
                      <IconButton
                        size="medium"
                        disabled={arrBack.length === 0}
                        onClick={() => getUndo()}
                      >
                        <UndoIcon
                          fontSize="medium"
                          sx={{
                            color: arrBack.length === 0 ? '#eeeeee' : '#e91e63',
                          }}
                        />
                      </IconButton>
                      <IconButton
                        size="medium"
                        disabled={arrNext.length === 0}
                        onClick={() => getRedo()}
                      >
                        <RedoIcon
                          fontSize="medium"
                          sx={{
                            color: arrNext.length === 0 ? '#eeeeee' : '#e91e63',
                          }}
                        />
                      </IconButton>
                      <IconButton size="medium" onClick={() => cleanText()}>
                        <CleaningServicesIcon
                          fontSize="medium"
                          sx={{
                            color: '#f44336',
                          }}
                        />
                      </IconButton>
                      <Divider orientation="vertical" flexItem />
                      <IconButton
                        size="medium"
                        onClick={() => openAddImageDialog()}
                      >
                        <LinkIcon fontSize="medium" sx={{ color: '#2196f3' }} />
                      </IconButton>
                      <IconButton size="medium" onClick={() => openAddDialog()}>
                        <LightbulbIcon
                          fontSize="medium"
                          sx={{ color: '#ff5722' }}
                        />
                      </IconButton>
                      <IconButton
                        size="medium"
                        onClick={() => openAddCloudDialog()}
                      >
                        <CloudDownloadIcon
                          fontSize="medium"
                          sx={{ color: '#00bcd4' }}
                        />
                      </IconButton>
                      <Divider orientation="vertical" flexItem />
                      <IconButton size="medium" onClick={() => zagolovok()}>
                        <TextFieldsIcon
                          fontSize="medium"
                          sx={{ color: '#455a64' }}
                        />
                      </IconButton>
                      <IconButton size="medium" onClick={() => podzagolovok()}>
                        <TitleIcon
                          fontSize="medium"
                          sx={{ color: '#607d8b' }}
                        />
                      </IconButton>
                      <IconButton size="medium" onClick={() => addEnter()}>
                        <SubdirectoryArrowRightIcon
                          fontSize="medium"
                          sx={{ color: '#90a4ae' }}
                        />
                      </IconButton>
                      <Divider orientation="vertical" flexItem />
                      <IconButton size="medium" onClick={() => boldText()}>
                        <FormatBoldIcon
                          fontSize="medium"
                          sx={{ color: '#212121' }}
                        />
                      </IconButton>
                      <IconButton size="medium" onClick={() => italicText()}>
                        <FormatItalicIcon
                          fontSize="medium"
                          sx={{ color: '#607d8b' }}
                        />
                      </IconButton>
                      <IconButton size="medium" onClick={() => noteBane()}>
                        <NoteIcon fontSize="medium" sx={{ color: '#00bcd4' }} />
                      </IconButton>
                      <Divider orientation="vertical" flexItem />
                      <Stack direction="row" alignItems="center" spacing={0}>
                        <Typography
                          style={{
                            fontFamily: 'sans-serif',
                            fontStyle: 'normal',
                            fontWeight: 400,
                            fontSize: '12px',
                          }}
                          component="text"
                        >
                          L1
                        </Typography>
                        <IconButton
                          size="medium"
                          onClick={() => listPointText()}
                        >
                          <FormatListBulletedIcon
                            fontSize="medium"
                            sx={{ color: '#009688' }}
                          />
                        </IconButton>
                      </Stack>
                      <Stack direction="row" alignItems="center" spacing={0}>
                        <Typography
                          style={{
                            fontFamily: 'sans-serif',
                            fontStyle: 'normal',
                            fontWeight: 400,
                            fontSize: '12px',
                          }}
                          component="text"
                        >
                          L2
                        </Typography>
                        <IconButton
                          size="medium"
                          onClick={() => listPointText2()}
                        >
                          <FormatListBulletedIcon
                            fontSize="medium"
                            sx={{ color: '#009688' }}
                          />
                        </IconButton>
                      </Stack>
                      <Stack direction="row" alignItems="center" spacing={0}>
                        <Typography
                          style={{
                            fontFamily: 'sans-serif',
                            fontStyle: 'normal',
                            fontWeight: 400,
                            fontSize: '12px',
                          }}
                          component="text"
                        >
                          L3
                        </Typography>
                        <IconButton
                          size="medium"
                          onClick={() => listPointText3()}
                        >
                          <FormatListBulletedIcon
                            fontSize="medium"
                            sx={{ color: '#009688' }}
                          />
                        </IconButton>
                      </Stack>
                      <Divider orientation="vertical" flexItem />
                      <Stack direction="row" alignItems="center" spacing={0}>
                        <Typography
                          style={{
                            fontFamily: 'sans-serif',
                            fontStyle: 'normal',
                            fontWeight: 400,
                            fontSize: '12px',
                          }}
                          component="text"
                        >
                          L1
                        </Typography>
                        <IconButton
                          size="medium"
                          onClick={() => listNumberText()}
                        >
                          <FormatListNumberedIcon
                            fontSize="medium"
                            sx={{ color: '#00bcd4' }}
                          />
                        </IconButton>
                      </Stack>
                      <Stack direction="row" alignItems="center" spacing={0}>
                        <Typography
                          style={{
                            fontFamily: 'sans-serif',
                            fontStyle: 'normal',
                            fontWeight: 400,
                            fontSize: '12px',
                          }}
                          component="text"
                        >
                          L2
                        </Typography>
                        <IconButton
                          size="medium"
                          onClick={() => listLetterText()}
                        >
                          <FormatListNumberedIcon
                            fontSize="medium"
                            sx={{ color: '#00bcd4' }}
                          />
                        </IconButton>
                      </Stack>
                    </Stack>
                  </Grid>
                  <Grid item xs={6}>
                    <Stack padding="10px" spacing={1}>
                      <MyTextFiledLection
                        id={`textarea${pageDto.id}`}
                        value={pageDto.text}
                        multiLine
                        onChange={(e) => addToRedo(e.target.value)}
                        size="small"
                        label=""
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={6}>
                    <Stack padding="10px" spacing={1}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        spacing={1}
                      >
                        <Stack height="10px" direction="row" spacing={1}>
                          {' '}
                        </Stack>
                      </Stack>
                      <Typography
                        id={`textareaClean${pageDto.id}`}
                        style={{
                          fontFamily: 'sans-serif',
                          fontSize: '14px',
                          overflow: 'auto',
                          fontWeight: '400',
                          textAlign: 'left',
                          lineHeight: '22px',
                          userSelect: 'text',
                        }}
                        component="html"
                      >
                        <div
                          // eslint-disable-next-line react/no-danger
                          dangerouslySetInnerHTML={{
                            __html: pageDto.text.replaceAll('#**#', '"'),
                          }}
                        />
                      </Typography>
                    </Stack>
                  </Grid>
                </Grid>
              )}
              {valueTabNew === SPACE_IMAGE_LINK && (
                <Grid container spacing={1}>
                  <MyButton
                    text="Удалить все ссылки"
                    background="#9c27b0"
                    width="250px"
                    height="50px"
                    onClick={() => handleDeleteAllImageLink()}
                  />
                  {pageDto.slideImages
                    .sort((a, b) => a.position - b.position)
                    .map((item) => (
                      <Grid item xs={12}>
                        <Stack spacing={1}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            <Typography
                              style={{
                                fontFamily: 'sans-serif',
                                fontStyle: 'normal',
                                fontWeight: 400,
                                fontSize: '18px',
                                color: '#000000',
                              }}
                              component="text"
                            >
                              Ссылка - {item.descr}
                            </Typography>
                            <IconButton
                              size="medium"
                              onClick={() =>
                                handleDeleteImage(item.id, IMAGE_TYPE, item)
                              }
                            >
                              <DeleteIcon
                                fontSize="medium"
                                sx={{
                                  color: '#f44336',
                                }}
                              />
                            </IconButton>
                          </Stack>
                          <Divider />
                          <WorksapceSlideImageItemDiv
                            idPage={pageDto.id}
                            dto={item}
                          />
                          <div style={{ marginBottom: '20px' }}> </div>
                        </Stack>
                      </Grid>
                    ))}
                </Grid>
              )}
              {valueTabNew === SPACE_TERMIN && (
                <Grid container spacing={1}>
                  {pageDto.annotations.map((item) => (
                    <Grid item xs={4}>
                      <Card style={{ width: '100%' }}>
                        <Stack padding="20px" spacing={1}>
                          <WorksapceAnnotationItemDiv
                            idPage={pageDto.id}
                            dto={item}
                            onUpdate={() => onUpdate()}
                          />
                        </Stack>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              )}
              {valueTabNew === SPACE_CLOUD && (
                <Grid container spacing={1}>
                  {pageDto.cloud.map((item) => (
                    <Grid item xs={12}>
                      <Stack spacing={1}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontWeight: 400,
                              fontSize: '18px',
                              color: '#000000',
                            }}
                            component="text"
                          >
                            Ссылка - {item.name}
                          </Typography>
                          <IconButton
                            size="medium"
                            onClick={() => handleDeleteCloudLink(item)}
                          >
                            <DeleteIcon
                              fontSize="medium"
                              sx={{
                                color: '#f44336',
                              }}
                            />
                          </IconButton>
                        </Stack>
                      </Stack>
                    </Grid>
                  ))}
                </Grid>
              )}
              {valueTabNew === SPACE_DESIGN && (
                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <Card style={{ width: '100%' }}>
                      <Stack padding="20px" spacing={1}>
                        <Stack direction="row" spacing={1}>
                          <IconButton
                            size="medium"
                            onClick={() => updateDesgin()}
                          >
                            <SaveIcon
                              fontSize="medium"
                              sx={{ color: '#9c27b0' }}
                            />
                          </IconButton>
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Stack
                            width="20px"
                            height="20px"
                            style={{
                              background: selectTheme(
                                pageDto.selectTextColor,
                                LIGHT_THEME,
                                -1
                              ),
                            }}
                          >
                            {' '}
                          </Stack>
                          <Stack
                            width="20px"
                            height="20px"
                            style={{
                              background: selectTheme(
                                pageDto.selectTextColor,
                                DARK_THEME,
                                -1
                              ),
                            }}
                          >
                            {' '}
                          </Stack>
                          <MyTextFiled
                            value={pageDto.selectTextColor}
                            onChange={(e) =>
                              setPageDto({
                                ...pageDto,
                                selectTextColor: e.target.value,
                              })
                            }
                            size="small"
                            label="Цвет ссылки"
                          />
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Stack
                            width="20px"
                            height="20px"
                            style={{
                              background: selectTheme(
                                pageDto.selectBackgroundColor,
                                LIGHT_THEME,
                                -1
                              ),
                            }}
                          >
                            {' '}
                          </Stack>
                          <Stack
                            width="20px"
                            height="20px"
                            style={{
                              background: selectTheme(
                                pageDto.selectBackgroundColor,
                                DARK_THEME,
                                -1
                              ),
                            }}
                          >
                            {' '}
                          </Stack>
                          <MyTextFiled
                            value={pageDto.selectBackgroundColor}
                            onChange={(e) =>
                              setPageDto({
                                ...pageDto,
                                selectBackgroundColor: e.target.value,
                              })
                            }
                            size="small"
                            label="Цвет выделенной ссылки"
                          />
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Stack
                            width="20px"
                            height="20px"
                            style={{
                              background: selectTheme(
                                pageDto.buttonColor,
                                LIGHT_THEME,
                                -1
                              ),
                            }}
                          >
                            {' '}
                          </Stack>
                          <Stack
                            width="20px"
                            height="20px"
                            style={{
                              background: selectTheme(
                                pageDto.buttonColor,
                                DARK_THEME,
                                -1
                              ),
                            }}
                          >
                            {' '}
                          </Stack>
                          <MyTextFiled
                            value={pageDto.buttonColor}
                            onChange={(e) =>
                              setPageDto({
                                ...pageDto,
                                buttonColor: e.target.value,
                              })
                            }
                            size="small"
                            label="Цвет кнопки"
                          />
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Stack
                            width="20px"
                            height="20px"
                            style={{
                              background: selectTheme(
                                pageDto.buttonColor2,
                                LIGHT_THEME,
                                -1
                              ),
                            }}
                          >
                            {' '}
                          </Stack>
                          <Stack
                            width="20px"
                            height="20px"
                            style={{
                              background: selectTheme(
                                pageDto.buttonColor2,
                                DARK_THEME,
                                -1
                              ),
                            }}
                          >
                            {' '}
                          </Stack>
                          <MyTextFiled
                            value={pageDto.buttonColor2}
                            onChange={(e) =>
                              setPageDto({
                                ...pageDto,
                                buttonColor2: e.target.value,
                              })
                            }
                            size="small"
                            label="Цвет текста кнопки"
                          />
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Stack
                            width="20px"
                            height="20px"
                            style={{
                              background: selectTheme(
                                pageDto.progressColor,
                                LIGHT_THEME,
                                -1
                              ),
                            }}
                          >
                            {' '}
                          </Stack>
                          <Stack
                            width="20px"
                            height="20px"
                            style={{
                              background: selectTheme(
                                pageDto.progressColor,
                                DARK_THEME,
                                -1
                              ),
                            }}
                          >
                            {' '}
                          </Stack>
                          <MyTextFiled
                            value={pageDto.progressColor}
                            onChange={(e) =>
                              setPageDto({
                                ...pageDto,
                                progressColor: e.target.value,
                              })
                            }
                            size="small"
                            label="Цвет прогресса"
                          />
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Stack
                            width="20px"
                            height="20px"
                            style={{
                              background: selectTheme(
                                pageDto.textColor,
                                LIGHT_THEME,
                                -1
                              ),
                            }}
                          >
                            {' '}
                          </Stack>
                          <Stack
                            width="20px"
                            height="20px"
                            style={{
                              background: selectTheme(
                                pageDto.textColor,
                                DARK_THEME,
                                -1
                              ),
                            }}
                          >
                            {' '}
                          </Stack>
                          <MyTextFiled
                            value={pageDto.textColor}
                            onChange={(e) =>
                              setPageDto({
                                ...pageDto,
                                textColor: e.target.value,
                              })
                            }
                            size="small"
                            label="Цвет текста"
                          />
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Stack
                            width="20px"
                            height="20px"
                            style={{
                              background: selectTheme(
                                pageDto.backgroundImage,
                                LIGHT_THEME,
                                -1
                              ),
                            }}
                          >
                            {' '}
                          </Stack>
                          <Stack
                            width="20px"
                            height="20px"
                            style={{
                              background: selectTheme(
                                pageDto.backgroundImage,
                                DARK_THEME,
                                -1
                              ),
                            }}
                          >
                            {' '}
                          </Stack>
                          <MyTextFiled
                            value={pageDto.backgroundImage}
                            onChange={(e) =>
                              setPageDto({
                                ...pageDto,
                                backgroundImage: e.target.value,
                              })
                            }
                            size="small"
                            label="Цвет фона изображения"
                          />
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Stack
                            width="20px"
                            height="20px"
                            style={{
                              background: selectTheme(
                                pageDto.backgroundText,
                                LIGHT_THEME,
                                -1
                              ),
                            }}
                          >
                            {' '}
                          </Stack>
                          <Stack
                            width="20px"
                            height="20px"
                            style={{
                              background: selectTheme(
                                pageDto.backgroundText,
                                DARK_THEME,
                                -1
                              ),
                            }}
                          >
                            {' '}
                          </Stack>
                          <MyTextFiled
                            value={pageDto.backgroundText}
                            onChange={(e) =>
                              setPageDto({
                                ...pageDto,
                                backgroundText: e.target.value,
                              })
                            }
                            size="small"
                            label="Цвет фона текста"
                          />
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Stack
                            width="20px"
                            height="20px"
                            style={{
                              background: selectTheme(
                                pageDto.backgroundDiv,
                                LIGHT_THEME,
                                -1
                              ),
                            }}
                          >
                            {' '}
                          </Stack>
                          <Stack
                            width="20px"
                            height="20px"
                            style={{
                              background: selectTheme(
                                pageDto.backgroundDiv,
                                DARK_THEME,
                                -1
                              ),
                            }}
                          >
                            {' '}
                          </Stack>
                          <MyTextFiled
                            value={pageDto.backgroundDiv}
                            onChange={(e) =>
                              setPageDto({
                                ...pageDto,
                                backgroundDiv: e.target.value,
                              })
                            }
                            size="small"
                            label="Цвет фона N/B"
                          />
                        </Stack>
                      </Stack>
                    </Card>
                  </Grid>
                </Grid>
              )}
              {valueTabNew === SPACE_AUDIO && (
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                        width="100%"
                      >
                        {pageDto.audio === '' && (
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontWeight: 400,
                              fontSize: '18px',
                              color: '#000000',
                            }}
                            component="text"
                          >
                            Нет аудиозаписи
                          </Typography>
                        )}
                      </Stack>
                      <AddFile
                        idPage={page}
                        workspaceDto={pageDto}
                        name="File"
                        type={AUDIO_TYPE}
                        singleFileOnly={false}
                        icon={
                          <FileUploadIcon
                            sx={{ color: '#9c27b0' }}
                            fontSize="large"
                          />
                        }
                        accept={ACCEPTED_INPUT_FORM_FILE_TYPES_MP3}
                        onUpdate={onUpdateFileUpload}
                      />
                    </Stack>
                  </Grid>
                  {pageDto.audio !== '' && (
                    <Grid item xs={12}>
                      <Card style={{ width: '100%' }}>
                        <Stack direction="row" padding="20px" spacing={1}>
                          <Stack>
                            <IconButton
                              size="medium"
                              onClick={() =>
                                handleDelete(pageDto.audio, AUDIO_TYPE)
                              }
                            >
                              <DeleteIcon
                                fontSize="medium"
                                sx={{
                                  color: '#f44336',
                                }}
                              />
                            </IconButton>
                          </Stack>
                          <audio
                            style={{
                              width: '100%',
                              height: '48px',
                            }}
                            src={`${RESOURCE_URL}/${section}/${route}/page_${page}/${pageDto.audio}`}
                            controls
                          />
                        </Stack>
                      </Card>
                    </Grid>
                  )}
                </Grid>
              )}
              {valueTabNew === SPACE_TABLE && (
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Card style={{ width: '100%' }}>
                      <Stack padding="20px" spacing={1}>
                        <Stack direction="row" spacing={1}>
                          <IconButton
                            size="medium"
                            onClick={() => updateTable()}
                          >
                            <SaveIcon
                              fontSize="medium"
                              sx={{ color: '#9c27b0' }}
                            />
                          </IconButton>
                        </Stack>
                        <MyTextFiled
                          value={pageDto.tableContent
                            .replaceAll('#**#', '\n')
                            .replaceAll('#*_*#', '"')}
                          multiLine
                          onChange={(e) =>
                            setPageDto({
                              ...pageDto,
                              tableContent: e.target.value,
                            })
                          }
                          size="small"
                          label="Содержимое таблицы"
                        />
                      </Stack>
                    </Card>
                  </Grid>
                </Grid>
              )}
            </AccordionDetails>
          </Accordion>
        </div>
      </Stack>
      <DialogConfirmation
        open={openDialogConfirmation}
        message="Вы точно хотите удалить данный файл?"
        onClose={deleteFile}
      />
      <DialogConfirmation
        open={openDialogImageConfirmation}
        message="Вы точно хотите удалить данный файл?"
        onClose={deleteFileImage}
      />
      <DialogConfirmation
        open={openDialogAllImageLinkConfirmation}
        message="Вы точно хотите удалить все ссылки?"
        onClose={deleteFileAllImageLink}
      />
      <DialogConfirmation
        open={openDialogAllImageConfirmation}
        message="Вы точно хотите удалить все изображения?"
        onClose={deleteFileAllImage}
      />
      <DialogConfirmation
        open={openDialogConfirmationCloudLink}
        message="Вы точно хотите удалить ссылку?"
        onClose={deleteCloudLink}
      />
      <DialogConfirmation
        open={openDialogDeletePageConfirmation}
        message="Вы точно хотите удалить слайд?"
        showCode
        onClose={deletePage}
      />
      <DialogAddAnnotation
        idPage={pageDto.id}
        open={openDialogTerminAdd}
        onSave={addTerminToText}
        onClose={() => setOpneDialogTerminAdd(false)}
      />
      <DialogGetFromCloud
        idPage={pageDto.id}
        open={openDialogCloudAdd}
        titleCloud={copyAddDto.text}
        isEdit={false}
        onSave={addCloudToText}
        onClose={() => setOpneDialogCloudAdd(false)}
      />
      <DialogAddImage
        idPage={pageDto.id}
        open={openDialogImageAdd}
        onSave={addImageToText}
        onClose={() => setOpneDialogImageAdd(false)}
        copyDto={copyAddDto}
        pageDto={pageDto}
      />
      <DialogAddToCloud
        pageNum={pageNum}
        open={openDialogCloud}
        onSave={onUpdate}
        onClose={() => setOpenDialogCloud(false)}
      />
    </Stack>
  );
};
